export const getAxisGridOptions = (building) => building?.extra?.axis_grids || [];

export const getAxisGridShape = (building, gridIndex) => {
  const options = getAxisGridOptions(building);
  const geodata = options?.[gridIndex]?.geodata;
  if (!geodata) return null;

  try {
    return JSON.parse(geodata);
  } catch {
    return null;
  }
};